import Axios from 'axios';
import VueCookie from 'vue-cookie'
import Constants from '@/shared/constants';
import CustomInterceptors from "@/api/auth/GAInterceptors";

const baseAxiosApi = Axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: process.env.VUE_APP_TIMEOUT
})

// baseAxiosApi.interceptors.request.use((config) => {
//   const COOKIE_FIELD_VALUE_STRING = 'value=';
//   let token = '';

//   const cookieValue = VueCookie.get(Constants.Auth.COOKIE);

//   if (cookieValue && cookieValue.indexOf(COOKIE_FIELD_VALUE_STRING) > -1) {
//     // cookie value contains the cookie data in the form of parameters
//     token = cookieValue.split('&').find(s => s.indexOf(COOKIE_FIELD_VALUE_STRING) > -1).replace(COOKIE_FIELD_VALUE_STRING, '');
//   } else if (cookieValue) {
//     // cookie value directly contains the token
//     token = cookieValue;
//   }

//   config.headers.common['Authorization'] = token;
//   return config;
// });

baseAxiosApi.interceptors.request.use(CustomInterceptors.GAInterceptors);

baseAxiosApi.interceptors.response.use(response => {
  return response;
}, CustomInterceptors.GAInterceptorsOnError);

export default baseAxiosApi

